export var NamedSystemBetTypes;
(function (NamedSystemBetTypes) {
    NamedSystemBetTypes["Trixie"] = "Trixie";
    NamedSystemBetTypes["Yankee"] = "Yankee";
    NamedSystemBetTypes["SuperYankee"] = "SuperYankee";
    NamedSystemBetTypes["Heinz"] = "Heinz";
    NamedSystemBetTypes["SuperHeinz"] = "SuperHeinz";
    NamedSystemBetTypes["Goliath"] = "Goliath";
    NamedSystemBetTypes["Patent"] = "Patent";
    NamedSystemBetTypes["Lucky15"] = "Lucky15";
    NamedSystemBetTypes["Lucky31"] = "Lucky31";
    NamedSystemBetTypes["Lucky63"] = "Lucky63";
})(NamedSystemBetTypes || (NamedSystemBetTypes = {}));
//# sourceMappingURL=NamedSystemBetTypes.js.map